import axios from 'axios';
import { from } from 'rxjs';

export const returnToV2 = () => {
  const post = axios.post('seller/returnToV2');
  const response$ = from(post);

  return response$;
};
